module.exports = __webpack_public_path__ + "static/kcdc-e5d639a8db8973921740508f9cef0626.jpg";